import { type TagDefinition, type TagRegistry, createStableTagId } from './tagRegistry'

/**
 * Canonical "Strong Moment" tag — author marks short bursts of high-intensity text.
 * Reserved: cannot be deleted from the UI. Rendered with the same side-bar look
 * as any other annotation tag.
 */
export const MOMENT_TAG_ID = createStableTagId('manifesto.moment')

export const MOMENT_TAG_NAME = 'רגע חזק'

export const MOMENT_TAG_DEFAULT: TagDefinition = {
  name: MOMENT_TAG_NAME,
  parentIds: [],
  color: '#FFC107',
  order: 25,
}

export function ensureProtectedMomentTag(registry: TagRegistry): TagRegistry {
  const existing = registry.tags[MOMENT_TAG_ID]
  // The moment tag's color identifies it visually across the whole editor, so we force
  // the canonical color on every load. To change it, edit MOMENT_TAG_DEFAULT.color above.
  if (existing && existing.color === MOMENT_TAG_DEFAULT.color) {
    return registry
  }
  const next: TagDefinition = existing ? { ...existing, color: MOMENT_TAG_DEFAULT.color } : { ...MOMENT_TAG_DEFAULT }
  return { ...registry, tags: { ...registry.tags, [MOMENT_TAG_ID]: next } }
}
